import React from 'react';
import PropTypes from 'prop-types';
import Tag from 'components/Tag';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'hooks/useAuth/useAuth';
import { useAssignment } from 'hooks/useAssignment/useAssignment';

const Assignments = ({
  className,
  driverId,
  vehiclesIds,
  driverConfirmed,
  withoutTag,
}) => {
  const { t } = useTranslation('Jobs');
  const { profile } = useAuth();
  const availableDrivers = profile && profile.colleagues;
  const availableVehicles = profile && profile.vehicles;
  const availableDriversAndVehicles = availableDrivers && availableVehicles;

  const { driverName, vehiclesPlates } = useAssignment(driverId, vehiclesIds);

  const renderAssignments = () => {
    if (availableDriversAndVehicles) {
      if (
        driverId &&
        (!vehiclesIds || vehiclesIds.length === 0) &&
        driverConfirmed
      ) {
        return (
          <>
            <div className="assignments__driver">{driverName}</div>
            {withoutTag ? (
              <div
                className="assignments__pending-text"
                data-testid="assignments__pending-vehicle"
              >
                {t('pendingVehicle')}
              </div>
            ) : (
              <Tag
                skin="red"
                text={t('pendingVehicle')}
                data-testid="assignments__pending-vehicle-tag"
              />
            )}
          </>
        );
      }

      if (vehiclesIds?.length > 0 && (!driverConfirmed || !driverId)) {
        return (
          <>
            {withoutTag ? (
              <div
                className="assignments__pending-text"
                data-testid="assignments__pending-driver"
              >
                {t('pendingDriver')}
              </div>
            ) : (
              <Tag
                className="assignments__driver-tag"
                skin="red"
                text={t('pendingDriver')}
                data-testid="assignments__pending-driver-tag"
              />
            )}
            <div className="assignments__vehicles">{vehiclesPlates}</div>
          </>
        );
      }

      if (driverId && vehiclesIds?.length > 0 && driverConfirmed) {
        return (
          <>
            <div className="assignments__driver">{driverName}</div>
            <div className="assignments__vehicles">{vehiclesPlates}</div>
          </>
        );
      }
    }

    return (
      <>
        {withoutTag ? (
          <div
            className="assignments__pending-text"
            data-testid="assignments__pending-assignment"
          >
            {t('pendingAssignment')}
          </div>
        ) : (
          <Tag
            skin="red"
            text={t('pendingAssignment')}
            data-testid="assignments__pending-assignment-tag"
          />
        )}
      </>
    );
  };

  return (
    <div className={className} data-testid="assignments">
      <div className="assignments">{renderAssignments()}</div>
    </div>
  );
};

Assignments.defaultProps = {
  driverId: '',
  vehiclesIds: [],
  driverConfirmed: false,
  showAtSide: false,
  withoutTag: false,
};

Assignments.propTypes = {
  className: PropTypes.string,
  driverId: PropTypes.number,
  vehiclesIds: PropTypes.array,
  driverConfirmed: PropTypes.bool,
  showAtSide: PropTypes.bool,
  withoutTag: PropTypes.bool,
};
export default Assignments;
